/**
 * Hair Quiz Newsletter - Middleware Integration
 */

(function () {
  'use strict';

  // Loader text (could be replaced with spinner HTML)
  var LOADER_HTML = '<span class="btn-primary__text anim">Loading...</span>';

  /**
   * Get URL parameters from current page
   * @returns {Object} Object containing handles and tags from URL
   */
  function getUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const handlesParam = urlParams.get('handles') || '';
    const tagsParam = urlParams.get('tags') || '';

    return {
      handles: handlesParam.split(',').filter(h => h.trim()),
      tags: tagsParam.split(',').filter(t => t.trim()),
    };
  }

  /**
   * Get results page URL with current query params
   * @returns {string} Results page URL
   */
  function getResultsUrl() {
    var resultsLink = document.getElementById('see-results-link');
    if (resultsLink && resultsLink.href) {
      return resultsLink.href;
    }
    // Fallback: build URL manually
    var params = getUrlParams();
    var queryString = '';
    if (params.handles.length > 0 || params.tags.length > 0) {
      var urlParams = new URLSearchParams();
      if (params.handles.length > 0) urlParams.set('handles', params.handles.join(','));
      if (params.tags.length > 0) urlParams.set('tags', params.tags.join(','));
      queryString = '?' + urlParams.toString();
    }
    return '/pages/hair-quiz-results' + queryString;
  }

  /**
   * Custom middleware request handler for hair-quiz
   * Adds quiz tags from URL and product SKUs to the middleware call
   */
  function middlewareRequestHairQuiz(form) {
    const $form = $(form);

    // Validate phone number if present
    var phoneComponent = $form.find('input-phone')[0];
    if (phoneComponent) {
      var phoneInput = phoneComponent.querySelector('input[type="tel"]');
      // Validate if field has value or is required
      if (phoneInput && phoneInput.value.trim() !== '') {
        if (!phoneComponent.validate()) {
          // Re-enable submit button if validation fails
          $form.find('button[type="submit"]').prop("disabled", false);
          return false;
        }
      }
    }

    const $submitButton = $form.find('button[type="submit"]');
    const originalButtonHTML = $submitButton.html();

    // Show loader
    $form.removeAttr('onsubmit'); // Avoid shopify recaptcha injection
    $submitButton.prop('disabled', true);
    $submitButton.html(LOADER_HTML);

    const res = $form.serializeArray();
    const { tags: quizTags } = getUrlParams();

    let tags = ['hair-quiz']; // Always include hair-quiz tag
    let email, name, phone, type, cookies, privacy = false, sms_consent = false;

    const skuCategoryMap = window.hairQuizSkuCategoryMap || [];

    if (quizTags && quizTags.length > 0) {
      tags = tags.concat(quizTags);
    }

    // Add product tags with category prefix
    // Format: hair-quiz-sku-{category}_{sku} (e.g. hair-quiz-sku-shampoo_71252)
    if (skuCategoryMap.length > 0) {
      tags = tags.concat(skuCategoryMap.map(item => 'hair-quiz-sku-' + item.category + '_' + item.sku));
    }

    // Collect data for middleware
    for (let i in res) {
      switch (res[i].name) {
        case 'contact[email]':
          email = res[i].value;
          break;

        case 'contact[userType]':
          type = res[i].value;
          break;

        case 'contact[first_name]':
          name = res[i].value;
          break;

        case 'customer[full_phone]':
          phone = res[i].value;
          if (phone && phone.length > 0) {
            tags.push('userPhoneNumber_' + phone);
            sms_consent = true;
          } else {
            tags.push('userPhoneNumber_');
          }
          break;

        case 'nw-privacy':
          privacy = res[i].value;
          break;

        case 'nw-cookies':
          cookies = res[i].value;
          if (cookies == 'true') {
            tags.push('userAcceptCookie_true');
          } else {
            tags.push('userAcceptCookie_false');
          }
          break;
      }
    }

    if (!tags.includes('userAcceptCookie_true') && !tags.includes('userAcceptCookie_false')) {
      tags.push('userAcceptCookie_false');
    }

    if (sms_consent) {
      tags.push('userAcceptSMS_true');
    } else {
      tags.push('userAcceptSMS_false');
    }

    if (privacy) {
      tags.push('userAcceptPrivacy_true');
    } else {
      tags.push('userAcceptPrivacy_false');
    }

    // Success callback - save to localStorage and redirect to results
    function onSuccess() {
      try {
        sessionStorage.setItem(
          'hairQuizInsiderPending',
          JSON.stringify({ email: email })
        );
      } catch (e) { }
      window.location.href = getResultsUrl();
    }

    // Send data to middleware with onSuccess callback
    if (typeof middleware !== 'undefined' && middleware.newsletter && middleware.newsletter.register) {
      middleware.newsletter.register(tags.join(','), email, privacy, name, type, cookies, sms_consent, $form, onSuccess);
    } else {
      // Reset button on error
      $submitButton.prop('disabled', false);
      $submitButton.html(originalButtonHTML);
    }
  }

  /**
   * Initialize hair quiz newsletter form with middleware
   */
  function init() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Check if we're on a hair-quiz page
    if (!window.location.pathname.includes('hair-quiz')) {
      return;
    }

    // Find all hair quiz newsletter forms on the page
    // The form is generated by include-newsletter.liquid and has class nw-to-middleware
    const forms = document.querySelectorAll('.dav-hair-quiz-newsletter form.nw-to-middleware');

    if (!forms || forms.length === 0) {
      // This is expected if the page doesn't have a newsletter form yet
      // or if simple_mode removed the wrapper structure
      return;
    }

    // Initialize each form found
    forms.forEach(function (form) {
      // Remove nw-to-middleware class to prevent double handler from newsletterSection in app.js
      form.classList.remove('nw-to-middleware');

      // Make form use javascript action (middleware)
      form.setAttribute('action', 'javascript:;');

      // Attach submit handler with custom middleware logic
      // Use capture phase to run before other handlers, and stopImmediatePropagation to prevent them
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        middlewareRequestHairQuiz(this);
      }, true);

      // Handle submitNewsletter event to re-enable button (for error cases)
      document.addEventListener('submitNewsletter', function () {
        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.disabled = false;
        }
      }, false);
    });
  }

  // Initialize
  init();
})();
